// Mock data for Lash Dollz Vk Beauty
// All data is **mocked** for frontend-only experience.

export const HERO_BANNER = {
  eyebrowText: "Lash Dollz Vk Beauty",
  title: "Premium Lash Education & Pro Lash Supplies",
  subtitle:
    "Build a thriving lash business with high-quality products, studio-tested tools, and step-by-step education.",
  ctaPrimary: {
    label: "Shop Lash Essentials",
    to: "/shop",
  },
  ctaSecondary: {
    label: "Book Now",
    to: "/bookings",
  },
  imageUrl:
    "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/jfd7fi8g_IMG_6390.jpeg",
};

// Product & training data used only where we don&apos;t yet have Shopify / real data.

export const SHOP_CATEGORIES = [
  {
    id: "cat-1",
    title: "Lash Products",
    handle: "lash-products",
    imageUrl:
      "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/ueqzjm1o_All%20products.jpeg",
    to: "/shop?category=lash-products",
  },
];

export const TRAINING_FEATURED = [
  {
    id: "train-3",
    name: "Classic & Hybrid Lash Training (In-Person)",
    handle: "classic-hybrid-training",
    description:
      "Fundamentals of classic and hybrid lash application, styling, and safe practice for artists in Tralee and beyond.",
    price: 350,
    compareAtPrice: 450,
    imageUrl:
      "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/6p9vxad8_IMG_6495.jpeg",
  },
  {
    id: "train-4",
    name: "Brow Training (In-Person)",
    handle: "brow-training",
    description:
      "Hands-on brow training designed to build confidence in mapping, shaping, and styling brows for your clients.",
    price: 320,
    compareAtPrice: 400,
    imageUrl:
      "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/ra4rmm7d_IMG_6203.jpeg",
  },
];

export const GET_THE_LOOK_SETS = [
  {
    id: "set-3",
    name: "Classic & Hybrid Lash Set",
    productHandle: "classic-hybrid-training",
    thumbnail:
      "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/6p9vxad8_IMG_6495.jpeg",
    description: "Signature classic and hybrid lash styling inspired by Lash Dollz Vk Beauty.",
    price: 0,
    compareAtPrice: null,
    soldOut: true,
  },
];

export const STUDIO_GALLERY = [
  {
    id: "gal-1",
    label: "Classic lashes before & after",
    service: "Classic lashes",
    imageUrl:
      "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/lrj89d1h_5D1BEFAA-C98D-46DD-8608-A9BA473D8A8B.jpeg",
  },
  {
    id: "gal-2",
    label: "Wispy mega volume lashes",
    service: "Wispy mega volume",
    imageUrl:
      "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/gd7edq6k_93F077E3-06FC-42EA-846E-EF2B4864139F.jpeg",
  },
  {
    id: "gal-3",
    label: "M curl volume lashes",
    service: "M curl volumes",
    imageUrl:
      "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/f223qg93_BDDDFA28-C36B-4EF7-8C52-429ACF606D37.jpeg",
  },
  {
    id: "gal-4",
    label: "Ombré lip blush",
    service: "Permanent makeup · lip blush",
    imageUrl:
      "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/lwettxxy_IMG_6203.jpeg",
  },
  {
    id: "gal-5",
    label: "Hybrid Lash Set",
    service: "Lash extensions",
    imageUrl:
      "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/6p9vxad8_IMG_6495.jpeg",
  },
  {
    id: "gal-6",
    label: "Award-winning artistry",
    service: "Awards 2025",
    imageUrl:
      "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/jfd7fi8g_IMG_6390.jpeg",
  },
  {
    id: "gal-7",
    label: "Pro tweezer collection",
    service: "Pro tools",
    imageUrl:
      "https://customer-assets.emergentagent.com/job_beauty-lashes-dupe/artifacts/zd6svbb3_IMG_3447.jpeg",
  },
];

export const SITE_META = {
  brandName: "Lash Dollz Vk Beauty",
  tagline: "Lash education, pro supplies, and training in Tralee, Co. Kerry.",
};
